// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarDay {
    border: none !important;
    border-radius: 50% !important;
    outline: none !important;
    color: var(--calendar-default-foreground);
}

.CalendarDay__selected,
.CalendarDay__selected,
.CalendarDay__selected:active,
.CalendarDay__selected:hover {
    background: var(--calendar-active-bg) !important;
    color: var(--calendar-active-foreground) !important;
}

.CalendarDay__selected_span,
.CalendarDay__hovered_span,
.CalendarDay__hovered_span:hover {
    background: var(--calendar-selected-span-bg) !important;
    color: var(--calendar-active-foreground) !important;
}

.CalendarDay__blocked_out_of_range,
.CalendarDay__blocked_out_of_range:active,
.CalendarDay__blocked_out_of_range:hover {
    background: var(--calendar-disabled-bg);
    color: var(--calendar-disable-foreground);
    cursor: not-allowed;
}

.CalendarDay__default:hover:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected):not(.CalendarDay__selected_span):not(.CalendarDay__highlighted_calendar):not(.CalendarDay__blocked_calendar) {
    background-color: var(--calendar-hover) !important;
    color: var(--calendar-active-foreground);
}

.CalendarDay__blocked_calendar, .CalendarDay__blocked_calendar:active, .CalendarDay__blocked_calendar:hover {
    background: var(--calendar-disable-foreground);
    border: 1px solid var(--calendar-disable-foreground);
    color: var(--calendar-default-foreground);
}`, "",{"version":3,"sources":["webpack://./src/styles/reactDatesCalendar.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;;;;IAII,gDAAgD;IAChD,mDAAmD;AACvD;;AAEA;;;IAGI,uDAAuD;IACvD,mDAAmD;AACvD;;AAEA;;;IAGI,uCAAuC;IACvC,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;IAC9C,oDAAoD;IACpD,yCAAyC;AAC7C","sourcesContent":[".CalendarDay {\n    border: none !important;\n    border-radius: 50% !important;\n    outline: none !important;\n    color: var(--calendar-default-foreground);\n}\n\n.CalendarDay__selected,\n.CalendarDay__selected,\n.CalendarDay__selected:active,\n.CalendarDay__selected:hover {\n    background: var(--calendar-active-bg) !important;\n    color: var(--calendar-active-foreground) !important;\n}\n\n.CalendarDay__selected_span,\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover {\n    background: var(--calendar-selected-span-bg) !important;\n    color: var(--calendar-active-foreground) !important;\n}\n\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:hover {\n    background: var(--calendar-disabled-bg);\n    color: var(--calendar-disable-foreground);\n    cursor: not-allowed;\n}\n\n.CalendarDay__default:hover:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected):not(.CalendarDay__selected_span):not(.CalendarDay__highlighted_calendar):not(.CalendarDay__blocked_calendar) {\n    background-color: var(--calendar-hover) !important;\n    color: var(--calendar-active-foreground);\n}\n\n.CalendarDay__blocked_calendar, .CalendarDay__blocked_calendar:active, .CalendarDay__blocked_calendar:hover {\n    background: var(--calendar-disable-foreground);\n    border: 1px solid var(--calendar-disable-foreground);\n    color: var(--calendar-default-foreground);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
